export default "__VITE_ASSET__Cc3ynvTW__"